// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
//@import "tailwindcss";
//@source "../../../node_modules/calendarkit-pro";
import { AppLayoutProps } from '@cloudscape-design/components/app-layout';
import TopNavigation from '@cloudscape-design/components/top-navigation';
import React, { ReactNode, useEffect, useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
// @ts-ignore: TS2614
import { AppLayoutToolbar, Autosuggest, Box, Button, Container, Divider, FileUpload, Flashbar, FormField, Grid, Header, Input, Link, List, Modal, SpaceBetween, Spinner, Textarea, TextContent } from '@cloudscape-design/components';
import Badge from '@cloudscape-design/components/badge';
import SideNavigation, { SideNavigationProps } from '@cloudscape-design/components/side-navigation';
import { mdiAlertOctagonOutline, mdiAlertOutline, mdiBriefcaseArrowLeftRightOutline, mdiBugStopOutline, mdiCalendarBadgeOutline, mdiCash, mdiChartBoxOutline, mdiCloseBoxOutline, mdiCreditCardSettingsOutline, mdiHumanMaleBoard, mdiInformationBoxOutline, mdiLogout, mdiMoonWaningCrescent, mdiPirate, mdiShieldAirplaneOutline, mdiStarOffOutline, mdiStarOutline, mdiSwapHorizontalCircleOutline, mdiWhiteBalanceSunny } from '@mdi/js';
import Icon from '@mdi/react';
import ReactJsonView from '@microlink/react-json-view';
import { format } from 'date-fns';
import parse from 'html-react-parser';
import config from '../../../scripts/config.json';
import '../../components/css/override.css';
import SelectUser, { SelectUserHandle } from '../../components/selects/selectUser';
import { fetchWithWatch } from '../../hooks/fetchWithWatch';
import { MenuItem } from '../../resources/types';
//import '../../styles/base.scss';
import { applyDensity, applyMode, Density, Mode } from '@cloudscape-design/global-styles';
import { jwtDecode } from 'jwt-decode';
import { fileToBase64, getCookie, getUrlVersion, resizeBase64Image, setCookie, setData, setDisplayName, setIdUser, setLoading, setMenu, setNotifications, setParameters, setVersion, storeJWT } from '../commons/functions';
import { LoadingOverlay } from '../commons/LoadingOverlay'; // Example corrected path
import { useGlobalState } from '../context/GlobalStateContext';
import { useLogger } from '../context/LoggerContext';

type HelpType = {
  value: string,
  label: string,
  description: string,
  tags: [],
  href: string
  idMenu?: number
}
type BadgeColor =
  | "blue"
  | "grey"
  | "green"
  | "red"
  | "severity-critical"
  | "severity-high"
  | "severity-medium"
  | "severity-low"
  | "severity-neutral";

type ItemBugReport = {
  bug: string;
  route: string;
  parameters: any;
  idUser: number;
  jsonImages: any[];
  eventLog: any[];
  version: string;
}
interface CustomAppLayoutProps extends AppLayoutProps {
  // initialHelpPanelPage: string; // Removed this line
}

interface DemoHeaderPortalProps {
  children: ReactNode;
}

const DemoHeaderPortal = ({ children }: DemoHeaderPortalProps) => {
  const domNode = document.querySelector('#h')!;
  return createPortal(children, domNode);
};

interface CustomSection extends SideNavigationProps.Section {
  section?: string;
  items: readonly SideNavigationProps.Item[]; // Match the exact type (required + readonly)
}

function sectionHasActiveLink(section: any, hash: string): boolean {
  let part = (hash.split("/")[0]);
  if (section && section.href && section.href.startsWith(part)) return true;
  if (section && section.section && section.section.startsWith(part)) return true;


  return false;
}

export function CustomAppLayout({ ...props }: CustomAppLayoutProps) {
  const { logHistory } = useLogger();

  //const { topMessages, setTopMessages } = useGlobalState();

  const [helpOptions, setHelpOptions] = useState<HelpType[]>([]);

  //const { state, actions, appLayoutRef } = useStore();
  const [idUserTemp, setIdUserTemp] = useState(0);
  const [navigationOpen, setNavigationOpen] = useState(false);
  const [showUserChoose, setShowUserChoose] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [currentHash, setCurrentHash] = useState(window.location.hash);
  const [showNavigation, setShowNavigation] = useState(true);
  const [showBugReport, setShowBugReport] = useState(false);
  const [bugError, setBugError] = useState("");
  const [helpText, setHelpText] = useState("");

  const [bugReport, setBugReport] = useState<ItemBugReport | null>(null);
  const { idUser, data, menu, parameters, version, loading, notifications, displayName, sdk } = useGlobalState();


  const getTimeLeft = (token: string) => {
    if (!token) return "00:00:00";

    try {
      const decoded = jwtDecode(token);
      const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
      const timeLeftInSeconds = decoded.exp - currentTime;

      // If token is already expired
      if (timeLeftInSeconds <= 0) {
        return "00:00:00";
      }

      // Calculate hours, minutes, and seconds
      const hours = Math.floor(timeLeftInSeconds / 3600);
      const minutes = Math.floor((timeLeftInSeconds % 3600) / 60);
      const seconds = timeLeftInSeconds % 60;

      // Pad with leading zeros to ensure HH:mm:ss format
      const paddedHours = String(hours).padStart(2, '0');
      const paddedMinutes = String(minutes).padStart(2, '0');
      const paddedSeconds = String(seconds).padStart(2, '0');

      return `${paddedHours}:${paddedMinutes}:${paddedSeconds}`;
    } catch (error) {
      console.error("Error decoding token:", error);
      return "00:00:00";
    }
  };
  const handleBugReport = async () => {
    try {
      const response = await fetch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/user/profile/bugreport',
          'JWT': getCookie("JWT"),
        },
        body: JSON.stringify(bugReport),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const dataTmp = await response.json();
      if (dataTmp.code === 0) {
        setBugReport({ bug: "", route: getHashPath(window.location.hash), parameters: parameters, eventLog: logHistory, idUser: idUser, jsonImages: [], version: config.version })
        setShowBugReport(false);
      }


    } catch (error: any) {
      console.error(error);
    } finally {
    }
  };
  const flattenMenu = (items: MenuItem[], parentLabel: string = ""): HelpType[] => {
    let result: HelpType[] = [];

    items.forEach((item) => {
      // Construct the current path: "Parent -> Current"
      const currentRoute = parentLabel
        ? `${parentLabel} -> ${item.text}`
        : item.text;

      // 1. Map the current item if it has a valid href
      if (item.href && item.href !== "" && !item.href.endsWith("default")) {
        result.push({
          value: item.href,
          label: currentRoute, // Now shows the full path
          description: item.description || '',
          tags: [],
          href: item.href,
          idMenu: item.idMenu,
        });
      }

      // 2. Recurse, passing the currentRoute as the new parentLabel
      if (item.items && item.items.length > 0) {
        const children = flattenMenu(item.items, currentRoute);
        result = [...result, ...children];
      }
    });

    return result;
  };
  useEffect(() => {
    const flattened = flattenMenu(menu);
    setHelpOptions(flattened);
  }, [menu]);

  if (!parameters.isClosed) setParameters({ ...parameters, isClosed: -1 })


  const filteredHelp = useMemo(() => {
    if (helpOptions.length === 0) return [];

    // Helper function to remove accents and special marks
    const normalize = (str: string) =>
      str
        .toString()
        .normalize("NFD")             // Decomposes symbols (e.g., ó -> o + ´)
        .replace(/[\u0300-\u036f]/g, "") // Removes the accent marks
        .toLowerCase();

    const searchWords = helpText
      .trim()
      .split(/\s+/)
      .filter(Boolean)
      .map(word => normalize(word)); // Normalize search input

    if (searchWords.length === 0 && helpOptions.length < 10) {
      return helpOptions;
    }

    if (helpText.trim().length < 2) return [];

    return helpOptions.filter(option => {
      // Normalize data fields for comparison
      const value = normalize(option.value);
      const description = normalize(option.description);
      const label = normalize(option.label);

      return searchWords.every(word =>
        description.includes(word) ||
        label.includes(word) ||
        value.includes(word)
      );
    });
  }, [helpOptions, helpText]);
  useEffect(() => {
    if (Object.keys(menu).length > 0) {
      // Recursive function to get all hrefs
      const getAllHrefs = (items: MenuItem[]): string[] => {
        return items.flatMap((item: any) => {
          const childHrefs = item.items ? getAllHrefs(item.items) : [];
          return item.href ? [item.href, ...childHrefs] : childHrefs;
        });
      };

      const hrefs = getAllHrefs(menu);
      // && !window.location.hash.endsWith("/default")
      const hash = "#" + getHashPath(window.location.hash);
      if (hash == "#" || hash == "") {
        window.location.hash = "#home"
        return;
      }

      if (
        hrefs.indexOf(hash) === -1 &&
        !hash.includes("page404") &&
        !hash.includes("user/")
      ) {
        window.location.hash = "#page404?route=" + hash;
      }
    }
  }, [menu]);
  const handleMasterDownload = () => {
    //ssetLoading(true);
    fetchWithWatch(`${getUrlVersion()}/routing/v1/?redirect3A`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-routing': '/private/user/login/data',
        'JWT': getCookie("JWT"),
      },
      body: JSON.stringify({ masters: [] }),
    }).then(async (response) => {
      if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
      const data2 = await response.json();
      if (data2.code === 0) {

        if (data2.code === 0) {
          if (data2.menu && data2.menu != menu) {
            setMenu(data2.menu);
          }
          if (data2.code === 0) {
            if (data2.masters) {
              //localStorage.setItem("data", JSON.stringify(data2.masters))
              setData(saveMasters(data2.masters, data))
            }
          }
        }
      }
    }).catch(err => console.error("Background fetch error", err)).finally(() => { setLoading(false); });
  }

  useEffect(() => {
    applyDensity(Density.Compact);
  }, []);
  useEffect(() => {
    if (parameters.theme === "light") applyMode(Mode.Light);
    else if (parameters.theme === "dark") applyMode(Mode.Dark);
    else applyMode(Mode.Light);
  }, [parameters?.theme]);
  const profileActions = [
    {
      id: 'preferences', text: 'Preferencias',

      items: [
        {
          id: 'password',
          text: 'Modificar contraseña',
          href: '#user/password',
        },
        {
          id: 'profilr',
          text: 'Mi perfil',
          href: '#user/profile',
        },
        {
          id: 'acks',
          text: 'Tomas de razón',
          href: '#user/acks',
        }
      ]
    },
    {
      id: 'system', text: 'Sistema', items: [
        {
          id: 'masters',
          text: 'Actualizar maestros',
        },
        {
          id: 'bugs',
          text: 'Notificar BUG',
        },
        {
          id: 'manual',
          text: "Manual de usuario",
        },
        {
          id: 'about',
          text: "Acerca de",
        },
      ]
    },
    {
      id: 'theme', text: 'Visualización', items: [
        {
          id: "theme.light", text: "Modo claro", itemType: "checkbox", checked: parameters.theme === "light" ? true : false,
          iconSvg: <Icon path={mdiWhiteBalanceSunny} size={0.75} />
        },
        {
          id: "theme.dark", text: "Modo oscuro", itemType: "checkbox", checked: parameters.theme === "dark" ? true : false,
          iconSvg: <Icon path={mdiMoonWaningCrescent} size={0.75} />
        },
      ]
    },
    { id: 'signout', text: 'Cerrar Sesión', href: '#user/logoff', iconSvg: <Icon path={mdiLogout} size={0.75} /> },
  ];
  useEffect(() => {
    if (parameters) {

      if (parameters.theme === undefined) {
        setParameters({ ...parameters, theme: "light" });
      }
      if (parameters.dummy === undefined) {
        setParameters({ ...parameters, dummy: true });
      }
      if (parameters.year === undefined) {
        setParameters({ ...parameters, year: new Date().getFullYear() });
      }
      if (parameters.month === undefined) {
        setParameters({ ...parameters, month: new Date().getMonth() + 1 });
      }
      if (parameters.period === undefined) {
        setParameters({ ...parameters, period: format(new Date(), 'yyyy-MM') });
      }
      if (parameters.startDate === undefined) {
        setParameters({ ...parameters, startDate: format(new Date(), 'dd-MM-yyyy') });
      }
      if (parameters.endDate === undefined) {
        setParameters({ ...parameters, endDate: format(new Date(), 'dd-MM-yyyy') });
      }
      if (parameters.date === undefined) {
        setParameters({ ...parameters, date: format(new Date(), 'dd-MM-yyyy') });
      }
      if (parameters.pageSize === undefined) {
        setParameters({ ...parameters, pageSize: 20 });
      }
      if (parameters.idCategories === undefined) {
        setParameters({ ...parameters, idCategories: [] });
      }
      if (parameters.idGroupTypes === undefined) {
        setParameters({ ...parameters, idGroupTypes: [] });
      }
      if (parameters.idFlightTypes === undefined) {
        setParameters({ ...parameters, idFlightTypes: [] });
      }
      if (parameters.idGroups === undefined) {
        setParameters({ ...parameters, idGroups: [] });
      }
      if (parameters.idStatuses === undefined) {
        setParameters({ ...parameters, idStatuses: [] });
      }
      if (parameters.idCharges === undefined) {
        setParameters({ ...parameters, idCharges: [] });
      }
      if (parameters.idChecks === undefined) {
        setParameters({ ...parameters, idChecks: [] });
      }
      if (parameters.idUserTypes === undefined) {
        setParameters({ ...parameters, idUserTypes: [] });
      }
      if (parameters.intersection === undefined) {
        setParameters({ ...parameters, intersection: 0 });
      }
      if (parameters.idUser === undefined) {
        setParameters({ ...parameters, idUser: 0 });
      }
      if (parameters.course === undefined) {
        setParameters({ ...parameters, course: "GLIDER" });
      }
      if (parameters.pilotType === undefined || parameters.pilotType === "") {
        setParameters({ ...parameters, pilotType: "PILOT" });
      }
      if (data.groupTypes && data.groupTypes.length > 0) {
        const val = data?.groupTypes[0]?.idBookingTypes;
        if (typeof val === 'string') {
          //console.log("handleMasterDownload")
          //handleMasterDownload()
        }
      }
    }
  }, [parameters]);


  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event && event.key) {
        const ctrl = event.ctrlKey;
        const alt = event.altKey;
        const key = event.key.toLowerCase();

        if (ctrl && alt && key === 'u') {
          setShowUserChoose(true);
          setTimeout(() => userRef.current?.focus(), 1);
        }

        if (ctrl && alt && key === 'j') {
          console.log(getCookie("JWT"))
          console.log(getTimeLeft(getCookie("JWT")))
        }
        if (ctrl && alt && key === 'd') {
          console.log(data)
        }

        if (ctrl && alt && key === 'm') {
          handleMasterDownload();
        }

        if (ctrl && alt && key === 'p') {
          console.log(parameters)
        }
        if (ctrl && alt && key === '0') {

          if (helpOptions != undefined && helpOptions.length > 0) {
            console.log(helpOptions.find((option: any) => option.href === window.location.hash)?.idMenu)
          }

        }
      };
    };

    // Add the listener
    window.addEventListener('keydown', handleKeyDown);

    // Cleanup when component unmounts or dependencies change
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [data, parameters]);



  const handleMarkRead = async (idMessage: number) => {
    try {

      handleLoadingState(idMessage);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/?session4`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/user/login/data',
          'JWT': getCookie("JWT"),
        },
        body: JSON.stringify({
          idMessage: idMessage
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const dataTmp = await response.json();
      if (dataTmp.serverVersion) {
        setVersion(dataTmp.serverVersion)
        if (dataTmp.serverVersion !== config.version) {
        }
      }
      else {
        setVersion("0.0.0")
      }
      if (dataTmp.code == 0) {
        if (dataTmp.oJWT) {
          if (dataTmp.oJWT.valid === false || dataTmp.oJWT.expired === true) {
            setCookie("JWT", "")
            storeJWT(dataTmp)
            if (!window.location.hash.startsWith("#user/")) {
              //window.location.href = '#user/login'
              return;
            }
          }
        }
        if (dataTmp.JWT && dataTmp.JWT === "") {
          if (!window.location.hash.startsWith("#user/")) {
            //window.location.href = '#user/login'
            return;
          }
        }
        setCookie("JWT", dataTmp.JWT)
        storeJWT(dataTmp)
        if (dataTmp.menu && dataTmp.menu.length > 0 && JSON.stringify(menu) !== JSON.stringify(dataTmp.menu)) {
          setMenu(dataTmp.menu);
          localStorage.setItem("menu", JSON.stringify(dataTmp.menu));
        }

        if (dataTmp.notifications) {
          setNotifications(dataTmp.notifications.map((n: any) => ({
            ...n,
            loading: false
          })));
        }
        if (dataTmp.UF && dataTmp.USD) {
          const updatedData = { ...data, UF: Number(dataTmp.UF), USD: Number(dataTmp.USD) };
          setData(updatedData);
        }
        if (dataTmp.counters) {
          const updatedData = { ...data, counters: dataTmp.counters };
          setData(updatedData);
        }

      }
      //http://[::1]:9615/#ops/mercenaries/pax?id=342747

      let currentHash = (window.location.hash).replace("#", "") || '';

      if (!window.location.hash.startsWith("#user/")) {
        if (dataTmp.codeLogin && dataTmp.codeLogin == -1) {
          //window.location.href = `#user/login?t=1&returnUrl=${encodeURIComponent(currentHash)}`;
          return;
        } else if (dataTmp.JWT === "") {
          //window.location.href = `#user/login?t=1&returnUrl=${encodeURIComponent(currentHash)}`;
          return;
        }
      }
    } catch (error: any) {
      console.error(error);
    } finally {
      handleLoadingState(idMessage);
    }
  };

  useEffect(() => {
    // Only run in development mode and on the client side
    if (typeof window !== 'undefined' && !getUrlVersion().includes("app.planeadores.cl")) {
      import('eruda').then((eruda) => {
        eruda.default.init();
        console.log("Eruda INIT")
      });
    }
  }, []);


  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    setNavigationOpen(!isMobile);
  }, [isMobile]);

  useEffect(() => {
    const onHashChange = () => setCurrentHash(window.location.hash);
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);


  useEffect(() => {
    //clearNotifications(setData);
  }, []);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash //getHashPath(window.location.hash);
      let show = true;
      show = !hash.startsWith('#user/') && !hash.startsWith('samples/')
      if (hash.startsWith('#user/profile') || hash.startsWith('#user/password') || hash.startsWith('#user/acks')) show = true
      if (hash.indexOf("/default") > 0) show = true
      setShowNavigation(show)
      //setShowNavigation(!hash.startsWith('user/') && !hash.startsWith('samples/') && hash!='user/profile' && hash!='user/password');
    };

    handleHashChange(); // run initially
    window.addEventListener('hashchange', handleHashChange);

    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  const [navItems, setNavItems] = useState<SideNavigationProps.Item[]>([]);

  const filterSideMenu = (items: any[]): any[] => {
    return items
      .map((item) => {
        const showItem = item.isSideMenu !== 0;
        const children = item.items ? filterSideMenu(item.items) : [];

        if (showItem || children.length > 0) {
          return {
            ...item,
            type: item.type || "link", // <- ensure type exists
            items: children.length > 0 ? children : item.items ? item.items.map((ci: any) => ({ ...ci, isSideMenu: 1, type: ci.type || "link" })) : [],
          };
        }

        return null;
      })
      .filter(Boolean);
  };

  useEffect(() => {
    if (!menu || Object.keys(menu).length === 0) return;

    const fetchNav = async () => {
      const filteredData = filterSideMenu(menu).filter(item => item.href !== '#home');

      const badgeData: Record<string, number> = {};
      const isSingleItem = filteredData.length === 1;

      const processedNav = filteredData.map((item, index) => {
        // Destructure to remove 'icon'. 
        // We extract 'icon' specifically, and keep everything else in 'restItem'
        const { icon, ...restItem } = item;

        return {
          ...restItem, // Spread the item without the icon
          items: item.items?.map((subItem: any) => {
            // Do the same for subItems if they also contain an icon
            const { icon: subIcon, ...restSubItem } = subItem;

            return {
              ...restSubItem,
              info:
                subItem.badge &&
                  subItem.badgeVariable &&
                  badgeData[subItem.badgeVariable] > 0 ? (
                  <Badge color={subItem.badgeColor as BadgeColor || "blue"}>
                    {badgeData[subItem.badgeVariable]}
                  </Badge>
                ) : undefined,
            };
          }),
          defaultExpanded: isSingleItem || sectionHasActiveLink(item, window.location.hash),
        };
      });
      setNavItems(processedNav || []);
    };

    fetchNav();
  }, [menu]);



  const notificationItems: any[] = notifications
    .filter((notification) => menuContainsHref(menu, notification.href) || notification.href === "")
    .filter(notification => notification.title !== "")
    .map((notification, index) => ({
      id: `notification-${index}`,
      type: "text",
      text: (
        <div style={{ width: 250 }}
          onClick={(e) => {
            if (notification.href && notification.href.trim() !== "")
              window.location.href = notification.href
          }}
        >

          <Grid
            disableGutters
            gridDefinition={[
              { colspan: 2 },
              { colspan: 9 },
              { colspan: 1 },
              { colspan: 2 },
              { colspan: 10 },
              { colspan: 6 },
              { colspan: 6 },
            ]}
          >
            <div>
              {notification.type === "CHECK" && (
                <Icon path={mdiHumanMaleBoard} size={1} color={notification.color !== "" ? notification.color : "white"} />
              )}
              {notification.type === "MERCENARY" && (
                <Icon path={mdiPirate} size={1} color={notification.color !== "" ? notification.color : "white"} />
              )}
              {notification.type === "ACCOUNT" && (
                <Icon path={mdiCash} size={1} color={notification.color !== "" ? notification.color : "white"} />
              )}
              {notification.type === "WEBPAY" && (
                <Icon path={mdiCreditCardSettingsOutline} size={1} color={notification.color !== "" ? notification.color : "white"} />
              )}
              {notification.type === "MOVEMENT" && (
                <Icon path={mdiBriefcaseArrowLeftRightOutline} size={1} color={notification.color !== "" ? notification.color : "white"} />
              )}
              {notification.type === "BOOKING" && (
                <Icon path={mdiCalendarBadgeOutline} size={1} color={notification.color !== "" ? notification.color : "white"} />
              )}
              {notification.type === "INFO" && (
                <Icon path={mdiInformationBoxOutline} size={1} color={notification.color !== "" ? notification.color : "white"} />
              )}
              {notification.type === "WARN" && (
                <Icon path={mdiAlertOutline} size={1} color={notification.color !== "" ? notification.color : "white"} />
              )}
              {notification.type === "DANGER" || notification.type === "ERROR" && (
                <Icon path={mdiAlertOctagonOutline} size={1} color={notification.color !== "" ? notification.color : "white"} />
              )}
              {notification.type === "SHIFT" && (
                <Icon path={mdiShieldAirplaneOutline} size={1} color={notification.color !== "" ? notification.color : "white"} />
              )}
              {notification.type === "POLL" && (
                <Icon path={mdiChartBoxOutline} size={1} color={notification.color !== "" ? notification.color : "white"} />
              )}
              {notification.type === "CASTLE" && (
                <Icon path={mdiSwapHorizontalCircleOutline} size={1} color={notification.color !== "" ? notification.color : "white"} />
              )}
            </div>
            <div><strong>{notification.title}</strong></div>
            <div onClick={(e) => {
              if (notification.idMessage > 0) {
                handleMarkRead(notification.idMessage);
                e.preventDefault();
                e.stopPropagation();
              }
            }}>

              <Box textAlign='right'>
                {notification.idMessage > 0 && !notification.loading && (
                  <Icon path={mdiCloseBoxOutline} size={1} />
                )}
                {notification.idMessage > 0 && notification.loading && (
                  <Spinner size="normal" />
                )}
              </Box>
            </div>
            <div></div>
            <div>{notification.notification}</div>
            <div><small>{notification.day}</small></div>
            <div style={{ float: "right" }}><small>{notification.time}</small></div>
          </Grid>

        </div>
      )
    }));
  const handleLoadingState = (id: number) => {
    setNotifications((prevNotifications) =>
      prevNotifications.map((n) =>
        n.idMessage === id ? { ...n, loading: true } : n
      )
    );
  };
  const navRef = useRef(null);
  const handleSetUserTemp = async () => {
    try {
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/admin/charges/list',
          'JWT': getCookie("JWT"),
        },

        body: JSON.stringify({ idUserTemp: idUserTemp })
      });
      if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

      const data = await response.json();
      if (data) {
        setShowUserChoose(false)
        setIdUser(data.idUser);
        setDisplayName(data.displayName);
        setCookie("JWT", data.JWT);
        //window.location.reload()
      }

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {

    }
  }

  useEffect(() => {
    if (idUserTemp && idUserTemp > 0)
      handleSetUserTemp()
  }, [idUserTemp]);

  interface UtilityItem {
    id: string;
    text: React.ReactNode;
    href: string;
    description: React.ReactNode;
    content: React.ReactNode;
  }

  function collectFavorites(items: MenuItem[], parents: string[] = []): any[] {
    let favorites: UtilityItem[] = [];

    items.forEach((item) => {
      const routeParts = [...parents]; // Only parents, exclude current item

      if (item.isFavorite === 1) {
        favorites.push({
          id: `favorite-${item.idMenu}`,
          //text: (<div style={{ width: 200 }}><FormField label={item.text}>{routeParts.join(" > ")}</FormField></div>),
          text: item.text,
          content: item.text,
          href: item.href ?? "#",
          description: (<small>{routeParts.join(" > ")}</small>),

        });
      }

      if (item.items && item.items.length > 0) {
        favorites.push(...collectFavorites(item.items, [...parents, item.text]));
      }
    });

    return favorites;
  }



  let utilities: any = []
  const favorites = collectFavorites(menu);

  if (getCookie("JWT") !== "") {

    if (!!favorites) utilities.push(

      {

        type: "menu-dropdown" as const,
        iconName: "star",
        title: "Favoritos",
        items: [],
        description: <SpaceBetween direction='vertical' size='xxxs'>
          <div style={{ width: 200 }}></div>
          <Divider />
          {favorites.length > 0 && (
            <List
              disableItemPaddings={true}
              items={favorites}
              renderItem={item => ({
                id: `asd${item.id}`,
                content: <Link onClick={() => { window.location.hash = item.href }}>
                  <div>{item.content}</div>
                  <Box variant="h4" padding={"xxs"}>
                    {item.description}
                  </Box>
                </Link>
              })} />
          )}
          {favorites.length === 0 && (
            <SpaceBetween direction='vertical' size='xxxs'>
              <Box textAlign='center' padding={"l"} variant="awsui-key-label">
                <Icon path={mdiStarOffOutline} size={1} /><br />
                No tiene favoritos registrados
              </Box>
              <Box>
                <div style={{ width: 200 }}>
                  Para agregar módulos a sus favoritos haga click en <Icon path={mdiStarOutline} size={0.75} /> en el módulo que desee agregar (Parte superior derecha de cada módulo)
                </div>
              </Box>
            </SpaceBetween>

          )
          }

        </SpaceBetween >,
      }
    )
    if (notificationItems && notificationItems.length > 0) utilities.push(
      {
        type: "menu-dropdown" as const,
        iconName: "notification",
        items: notificationItems,
        badge: true,
      })
    utilities.push({
      type: "menu-dropdown" as const,
      text: "",
      iconName: "user-profile",
      items: profileActions,
      onItemClick: (event: any) => {
        if (event.detail.id === "signout") {
          window.location.href = "#user/logout";
        }
        if (event.detail.id === "theme.dark") {
          setParameters({ ...parameters, theme: "dark" });
        }
        if (event.detail.id === "theme.light") {
          setParameters({ ...parameters, theme: "light" });
        }
        if (event.detail.id === "masters") {
          handleMasterDownload()
        }
        if (event.detail.id === "bugs") {

          setBugReport({ bug: "", route: getHashPath(window.location.hash), parameters: parameters, eventLog: logHistory, idUser: idUser, jsonImages: [], version: config.version })
          setShowBugReport(true);
        }
        if (event.detail.id === "about") {
          setShowUpdate(true);
        }
        if (event.detail.id === "manual") {
          window.open(`/resources/manuals/user.manual.aspx?id=${idUser}`, "_blank");
        }
      },
    });

  }
  const customStyles = `
    [class*="awsui_page-item_"] li {
      margin: 0 !important;
      padding: 0 !important;
    }`;
  const userRef = useRef<SelectUserHandle>(null);


  const [files, setFiles] = React.useState<File[]>([]);


  const handleFileChange = async (files: File[]) => {
    if (!bugReport) return;

    const base64Results = await Promise.all(files.map(fileToBase64));
    const resizedResults = await Promise.all(
      base64Results.map(async (result) => {
        const base64WithPrefix = result.base64.startsWith("data:")
          ? result.base64
          : `data:${result.file.type};base64,${result.base64}`;
        const resizedBase64 = await resizeBase64Image(base64WithPrefix, 800, 0.7);
        const cleanedBase64 = resizedBase64.replace(/^data:image\/\w+;base64,/, "");


        return {
          fileName: result.file.name,
          fileContent: cleanedBase64,
          fileSize: result.file.size
        };
      })
    );
    setBugReport((prev: ItemBugReport | null) => {
      if (!prev) return prev;
      return {
        ...prev,
        // Use the spread operator on the entire new array to append all new files
        jsonImages: resizedResults
      };
    });
    //} catch (error) {
    //   console.error('Error reading files:', error);
    // Handle error state if necessary
    //}
  };
  const awsImage = (
    <img
      src="resources/AWS.CS.jpg"
      alt="placeholder"
    />
  );
  const netImage = (
    <img
      src="resources/NET.CORE.jpg"
      alt="placeholder"
    />
  );

  const flashbarItems = (data.flashbar || []).map((n: any) => ({
    id: n.id,
    content: typeof n.content === 'string' ? parse(n.content) : n.content,
    type: n.type,
    dismissible: true,
    onDismiss: () => {
      setData((prev: any) => {
        const filtered = prev.flashbar.filter((item: any) => item.id !== n.id);
        const updatedData = { ...prev, flashbar: filtered };
        localStorage.setItem("data", JSON.stringify(updatedData));
        return updatedData;
      });
    }
  }));
  const isUpdateAvailable = (current: string, available: string) => {
    const v1 = current.split('.').map(Number);
    const v2 = available.split('.').map(Number);
    if (!v1 || !v2 || v1.length !== 3 || v2.length !== 3) return false;
    for (let i = 0; i < Math.max(v1.length, v2.length); i++) {
      const part1 = v1[i] || 0; // Default to 0 if part is missing (e.g., "1.2" vs "1.2.1")
      const part2 = v2[i] || 0;

      if (part2 > part1) return true;  // Available version is higher
      if (part2 < part1) return false; // Current version is already higher
    }

    return false; // Versions are identical
  };
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    if (params.has('reload')) {
      // 1. Create a clean URL
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.delete('reload');
      window.history.replaceState({}, document.title, newUrl.toString());

      //console.log('Reload parameter removed successfully.');
    }
  }, []); // Run only once on mount
  return (
    <>
      <Modal visible={showUserChoose}
        header={"Seleccione usuario"}
        size='small'
        onDismiss={() => setShowUserChoose(false)}
      >
        <SelectUser ref={userRef} onConfirm={(selected) => { setIdUserTemp(selected?.idUser || 0); }}>

        </SelectUser>
      </Modal>
      <DemoHeaderPortal>
        <TopNavigation

          identity={{
            title: 'CPV',
            href: '#home',
          }}
          utilities={utilities}

          search=
          {helpOptions.length > 0 && window.location.hash !== "#user/login" && !!idUser && idUser > 0 && (
            <Autosuggest
              value={helpText}
              expandToViewport
              filteringType="none"
              hideEnteredTextOption
              onChange={(event) => setHelpText(event.detail.value)}
              options={filteredHelp}
              onSelect={(event) => {
                if (event.detail && event.detail.value !== "") {
                  window.location.hash = event.detail.value;
                }
              }}
              placeholder='Ayuda'
            />
          )}
        />
        <TextContent>
          <div style={{ margin: 0, paddingLeft: 10, paddingBottom: 5, paddingTop: 3, backgroundColor: "#161d26", color: "white" }}>
            <small style={{ color: "white" }}>Versión  {config.version}{!getUrlVersion().includes("//app.") ? <span style={{ color: "orange", fontWeight: "bold" }}> {`{BETA}`}</span> : ""}</small> {displayName && displayName !== "" && (<>| <small style={{ color: "white" }}><strong>{displayName}</strong></small></>)}
            {/** {getTimeLeft(getCookie("JWT"))} */}
          </div>
        </TextContent >

      </DemoHeaderPortal >
      <AppLayoutToolbar
        notifications={
          < Flashbar items={flashbarItems} />
        }
        contentType='form'
        navigationWidth={200}
        navigation={showNavigation ? <div ref={navRef}>< SideNavigation header={{ href: "#home", text: "Inicio" }}
          activeHref={
            currentHash.split('/').length < 3
              ? currentHash
              : currentHash.split('/').slice(0, 2).join('/') + "/default"
          }
          items={navItems} /></div > : undefined}
        navigationOpen={showNavigation && navigationOpen}
        onNavigationChange={({ detail }) => setNavigationOpen(detail.open)}
        splitPanelPreferences={{
          position: 'side',
        }}

        onSplitPanelPreferencesChange={() => { }}
        {...props}
      />
      {loading && <LoadingOverlay theme={parameters.theme} />}
      <Modal visible={showBugReport}
        footer={
          <Box float="right">
            <Button variant="link" onClick={() => setShowBugReport(false)}>Cancelar</Button>
            <Button variant="primary" onClick={() => handleBugReport()}>Enviar reporte</Button>
          </Box>
        }
        header={<Header variant="h2"
          description={`Versión ${config.version}`}
        ><Icon path={mdiBugStopOutline} size={1} /> Notificar un error / bug</Header>}

        size='large'
        onDismiss={() => setShowBugReport(false)}

      >
        <SpaceBetween size="l" direction='vertical'>
          <FormField label="Error">
            <Textarea onChange={(detail) =>
              setBugReport((prev) => prev ? { ...prev, bug: detail.detail.value } : prev)
            }
              value={bugReport?.bug || ""}
              placeholder="Describa el problema aquí..."></Textarea>
          </FormField>
          <FileUpload
            onChange={({ detail }) => {
              const newFiles = detail.value.slice(0, 3);
              setFiles(newFiles);
              handleFileChange(newFiles);
            }}
            accept="image/*"
            value={files}
            i18nStrings={{
              uploadButtonText: e =>
                "Agregar captura",
              dropzoneText: e =>
                "Arrastre archivo para cargar",
              removeFileAriaLabel: e =>
                `Eliminar archivo ${e + 1}`,
              limitShowFewer: "Show fewer files",
              limitShowMore: "Show more files",
              errorIconAriaLabel: "Error",
              warningIconAriaLabel: "Warning"
            }}
            multiple
            showFileSize
            showFileThumbnail
            fileTokenAlignment="horizontal"
            tokenLimit={3}
          />

          <FormField label="Routing">
            <Input readOnly value={window.location.hash} />
          </FormField>
          <SpaceBetween size="l" direction='horizontal'>
            <FormField label="Event Log">
              <ReactJsonView src={logHistory}
                theme={parameters.theme === "light" ? "rjv-default" : "ashes"}
                name={false}
                style={{ minHeight: 300, minWidth: 300 }}
                collapsed={1}
                collapseStringsAfterLength={30}
                groupArraysAfterLength={10}
                displayObjectSize={false}
                displayDataTypes={false}
                enableClipboard={false}
              />
            </FormField>
            <FormField label="oParameters">
              <ReactJsonView src={parameters}
                theme={parameters.theme === "light" ? "rjv-default" : "ashes"}
                name={false}
                style={{ minHeight: 300, minWidth: 300 }}
                collapsed={1}
                collapseStringsAfterLength={30}
                groupArraysAfterLength={10}
                displayObjectSize={false}
                displayDataTypes={false}
                enableClipboard={false}
              />
            </FormField>
          </SpaceBetween>
        </SpaceBetween>
      </Modal>


      <Modal visible={showUpdate}
        header={"Acerca de CPVAPP"}
        size='small'
        onDismiss={() => setShowUpdate(false)}

      >
        <SpaceBetween size="l" direction='vertical'>
          <Container
            media={{
              content: netImage,
              position: "side",
              width: "33%"
            }}
          >
            <FormField label="SDK" info={<Link>NET.Core 8.0</Link>}>
              {sdk}
            </FormField>

          </Container>

          <Container
            media={{
              content: awsImage,
              position: "side",
              width: "33%"
            }}
          >
            <FormField label="UIX" info={<Link>Cloudscape AWS</Link>}>
              {config.version}
            </FormField>
          </Container>
        </SpaceBetween>
      </Modal>
    </>
  );
}

function menuContainsHref(menu: MenuItem[], href: string): boolean {
  for (const item of menu) {
    if (item.href === href) return true;
    if (item.items && menuContainsHref(item.items, href)) return true;
  }
  return false;
}

function getHashPath(hash: string): string {
  const questionMarkIndex = hash.indexOf('?');
  if (questionMarkIndex !== -1) {
    return hash.substring(1, questionMarkIndex);
  }
  return hash.substring(1);
}
export function saveMasters(masters: any, dataTemp: any) {
  if (masters && dataTemp) {
    if (masters.checks) { dataTemp.checks = masters.checks; }
    if (masters.accountPlans) { dataTemp.accountPlans = masters.accountPlans; }
    if (masters.bookingTypes) { dataTemp.bookingTypes = masters.bookingTypes; }
    if (masters.categories) { dataTemp.categories = masters.categories; }
    if (masters.charges) { dataTemp.charges = masters.charges; }
    if (masters.groupTypes) { dataTemp.groupTypes = masters.groupTypes; }
    if (masters.groups) { dataTemp.groups = masters.groups; }
    if (masters.usersStatuses) { dataTemp.usersStatuses = masters.usersStatuses; }
    if (masters.usersTypes) { dataTemp.usersTypes = masters.usersTypes; }
    if (masters.equipments) { dataTemp.equipments = masters.equipments; }
    if (masters.makes) { dataTemp.makes = masters.makes; }
    if (masters.users) { dataTemp.users = masters.users; }
    if (masters.complaintCategories) { dataTemp.complaintCategories = masters.complaintCategories; }
    if (masters.complaintTypes) { dataTemp.complaintTypes = masters.complaintTypes; }
    if (masters.countries) { dataTemp.countries = masters.countries; }

    localStorage.setItem("data", JSON.stringify(dataTemp))
    setData(dataTemp)
    return dataTemp;
  }

}